<div class="conatiner-div d-flex flex-column">
  <div class="topHead d-flex justify-content-between">
    <span>Search data</span>
    <div class="close-button" mat-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  <!-- <form class="d-flex flex-column search-div"> -->
  <div class="filter-div">
  <div class="d-flex flex-column input-div">
    <span class="input-text">Serial Number</span>
    <input class="search-input dp-input-control" type="tel" placeholder="Enter Sl. No" aria-label="Search"
      [formControl]="slNo" />
  </div>
   
  @if(showAllFilter){
    <div class="d-flex flex-column input-div">
    <span class="input-text">Show Phil Mismatch Records</span>
    <input class="search-input dp-input-control" type="text" placeholder="Select Any Options" [formControl]="matchId"
      [matAutocomplete]="autoMismatch" aria-label="Search" />
    <mat-autocomplete autoActiveFirstOption #autoMismatch="matAutocomplete" [displayWith]="displayFn">
      @for (item of misMatchArr; track item) {
      <mat-option [value]="item">{{
        item.name
        }}</mat-option>
      }
    </mat-autocomplete>
  </div>
  <div class="d-flex flex-column input-div">
    <span class="input-text">Family Code</span>
    <input class="search-input dp-input-control" minlength="12" maxlength="12" type="tel"
      placeholder="Enter Family Code" aria-label="Search" [formControl]="fc" />
  </div>
  <div class="d-flex flex-column input-div">
    <span class="input-text">Pincode</span>
    <input class="search-input dp-input-control" type="tel" placeholder="Enter Pincode" aria-label="Search"
      [formControl]="pin" [matAutocomplete]="autopin" maxlength="6" />
    <mat-autocomplete autoActiveFirstOption #autopin="matAutocomplete">
      @for (item of pincodeList ; track item) {
      <mat-option [value]="item">{{
        item
        }}</mat-option>
      }
    </mat-autocomplete>
  </div>
  <div class="d-flex flex-column input-div">
    <span class="input-text">Updated By</span>
    <input class="search-input dp-input-control" type="text" placeholder="Enter FW Name" [formControl]="fwName"
      [matAutocomplete]="auto" aria-label="Search" />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
      @for (item of fwNameList ; track item) {
      <mat-option [value]="item">{{
        item.name
        }}</mat-option>
      }
    </mat-autocomplete>
  </div>
  @if(this.data.superUser){
  <div class="d-flex flex-column input-div">
    <span class="input-text">Reviewed By</span>
    <input class="search-input dp-input-control" type="text" placeholder="Enter DA Name" [formControl]="daName"
      [matAutocomplete]="autoRev" aria-label="Search" />
    <mat-autocomplete autoActiveFirstOption #autoRev="matAutocomplete" [displayWith]="displayFn">
      @for (item of daNameList; track item) {
      <mat-option [value]="item">{{
        item.name
        }}</mat-option>
      }
    </mat-autocomplete>
  </div>
}
  <div class="d-flex flex-column input-div">
    <span class="input-text">From Date</span>
     <input class="search-input dp-input-control" type="date" placeholder="dd/mm/yyyy" aria-label="Search"
      [formControl]="fromDate" />
  </div>
  <div class="d-flex flex-column input-div">
    <span class="input-text">To Date</span>
     <input class="search-input dp-input-control" type="date" placeholder="dd/mm/yyyy" aria-label="Search"
      [formControl]="toDate" />
  </div>
  <div class="d-flex flex-column input-div">
    <span class="input-text">Status</span>
    <mat-select [formControl]="statusControl" placeholder="Select Status" class="select-mat-form-field">
      <mat-option *ngFor="let option of selectStatusList" [value]="option.value">
        {{ option.viewValue }}
      </mat-option>
    </mat-select>
  </div>
  @if(this.data.superUser){
  <div class="d-flex flex-column input-div">
    <span class="input-text">Review Status</span>
    <mat-select [formControl]="memStatus" placeholder="Select Member Status" class="select-mat-form-field">
      <mat-option *ngFor="let option of selectMemStatus" [value]="option.value">
        {{ option.viewValue }}
      </mat-option>
    </mat-select>
  </div>
  }
 
  <!-- @if(isMobileDevice){

  <div class="d-flex flex-column input-div">
    <span class="input-text">Sort By Date</span>
    <mat-form-field class="select-mat-form-field custom-select-form">
      <mat-select [formControl]="sort" placeholder="Sort by date" class="select-mat-form-field" style="border:none">
        <mat-option *ngFor="let option of dateSorting" [value]="option.value">
          {{ option.viewValue }}
        </mat-option>
      </mat-select>
      @if(sort.value!==''){
      <button mat-icon-button matSuffix (click)="clearSorting()" class="clear-button">
        <mat-icon class="clear-icon">clear</mat-icon>
      </button>
      }
    </mat-form-field>
  </div>
  } -->
  }
  <!-- </form> -->
  <div class="d-flex btn-main-div">
    <button class="dp-secondary-btn btn-div" (click)="onClearClick()">
      Clear all
    </button>

    <button class="dp-primary-btn btn-div" (click)="onSearchClick()">
      Search
    </button>
  </div>
  </div>
</div>